import Hero from "../../components/Hero";
import CalculatorsImag1 from "../../../assets/images/Calculator1.jpg";
import HowMuchWillItCostCalculator from "../../calculators/HowMuchWillItCostCalculator";

const HowMuchWillItCostPage = () => {
  return (
    <div>
      <Hero
        title="How Much Will It Cost"
        subtitle=""
        backgroundImage={CalculatorsImag1}
      />
      <HowMuchWillItCostCalculator />
      {/* <div className="landing-page">
            </div> */}
    </div>
  );
};

export default HowMuchWillItCostPage;
